import { Model } from '@nozbe/watermelondb'
import { field, date, readonly, children } from '@nozbe/watermelondb/decorators'

export default class Merchant extends Model {
    static table = 'merchants'
    static associations = {
        stores: { type: 'has_many', foreignKey: 'merchant_id' },
        users: { type: 'has_many', foreignKey: 'merchant_id' },
        settings: { type: 'has_many', foreignKey: 'merchant_id' },
        user_invitations: { type: 'has_many', foreignKey: 'merchant_id' },
    } as const

    @field('business_name') businessName!: string
    @field('business_type') businessType!: string | null
    @field('gstin') gstin!: string | null
    @field('pan') pan!: string | null
    @field('phone') phone!: string
    @field('email') email!: string | null
    @field('address') address!: string | null
    @field('city') city!: string | null
    @field('state') state!: string | null
    @field('pincode') pincode!: string | null
    @field('logo_url') logoUrl!: string | null
    @field('plan_tier') planTier!: string
    @field('onboarding_status') onboardingStatus!: string
    @field('approved_by_id') approvedById!: string | null
    @date('approved_at') approvedAt!: Date | null
    @field('rejection_reason') rejectionReason!: string | null
    @field('subscription_plan') subscriptionPlan!: string
    @field('max_stores') maxStores!: number
    @field('max_users') maxUsers!: number
    @field('owner_phone') ownerPhone!: string | null
    @field('plan_status') planStatus!: string
    @date('plan_expires_at') planExpiresAt!: Date | null
    @field('max_devices') maxDevices!: number
    @field('is_active') isActive!: boolean
    @field('version') version!: number
    @field('is_synced') isSynced!: boolean
    @field('is_deleted') isDeleted!: boolean
    @readonly @date('created_at') createdAt!: Date
    @readonly @date('updated_at') updatedAt!: Date

    @children('stores') stores: any
    @children('users') users: any
    @children('user_invitations') invitations: any
}
